/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TapeMiniReference,
    TapeMiniReferenceFromJSON,
    TapeMiniReferenceFromJSONTyped,
    TapeMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface TapeGroupUpdate
 */
export interface TapeGroupUpdate {
    /**
     * 
     * @type {Array<TapeMiniReference>}
     * @memberof TapeGroupUpdate
     */
    tapes: Array<TapeMiniReference>;
    /**
     * 
     * @type {string}
     * @memberof TapeGroupUpdate
     */
    name: string;
}

export function TapeGroupUpdateFromJSON(json: any): TapeGroupUpdate {
    return TapeGroupUpdateFromJSONTyped(json, false);
}

export function TapeGroupUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeGroupUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tapes': ((json['tapes'] as Array<any>).map(TapeMiniReferenceFromJSON)),
        'name': json['name'],
    };
}

export function TapeGroupUpdateToJSON(value?: TapeGroupUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tapes': ((value.tapes as Array<any>).map(TapeMiniReferenceToJSON)),
        'name': value.name,
    };
}


